import { render } from "./customerStatisticsTotal.vue?vue&type=template&id=dc59efda"
import script from "./customerStatisticsTotal.vue?vue&type=script&lang=js"
export * from "./customerStatisticsTotal.vue?vue&type=script&lang=js"

import "./customerStatisticsTotal.vue?vue&type=style&index=0&id=dc59efda&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__